import React from 'react';
import { Box, Container, Typography, Paper, Divider } from '@mui/material';

const PrivacyPolicyPage: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={2} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom sx={{ fontWeight: 600, mb: 3 }}>
          POLÍTICA DE PRIVACIDADE
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            1. Introdução
          </Typography>
          <Typography variant="body1" paragraph>
            Esta Política de Privacidade explica como REEDY EDITORA, PRODUTOS E SERVIÇOS DIGITAIS LTDA, CNPJ 61.561.119/0001-28, nome fantasia REEDY ("Reedy", "nós"), trata os dados pessoais de pessoas que interagem com nosso aplicativo, website e serviços ("Plataforma"), inclusive na condição de usuários finais vinculados a parceiros empresariais ("Parceiros").
          </Typography>
          <Typography variant="body1" paragraph>
            Para fins desta Política, a Reedy atua como Controladora dos dados pessoais (Lei 13.709/2018 – LGPD).
          </Typography>
          <Typography variant="body1" paragraph>
            Ao se cadastrar, navegar ou utilizar a Plataforma (ou clicar em "Eu aceito"), você concorda com esta Política. Recomendamos a leitura cuidadosa e a verificação periódica de atualizações.
          </Typography>
          <Typography variant="body1" paragraph>
            Canal de contato (inclusive DPO): suporte@reedy.com.br
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            2. Objetivos desta Política
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>2.1.</strong> Explicar quais dados coletamos, como e por que os tratamos, com qual base legal, com quem podemos compartilhar e por quanto tempo os mantemos.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>2.2.</strong> Detalhar seus direitos como titular e como exercê-los.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>2.3.</strong> Dar transparência sobre parcerias B2B, sem vinculação a Parceiros específicos (lista não é publicada nesta Política).
          </Typography>
          <Typography variant="body1" paragraph>
            Se você não concordar com esta Política, poderá optar por não utilizar a Plataforma.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            3. Dados Pessoais Tratados
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>3.1. Dados fornecidos pelo usuário (cadastro e identificação)</strong>
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">Nome completo</Typography></li>
            <li><Typography variant="body1">CPF</Typography></li>
            <li><Typography variant="body1">E-mail</Typography></li>
            <li><Typography variant="body1">Telefone celular</Typography></li>
            <li><Typography variant="body1">Data de nascimento</Typography></li>
          </Box>
          <Typography variant="body1" paragraph>
            <strong>3.2. Dados eventualmente solicitados para finalidades específicas</strong>
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">RG, endereço (por ex., para envio de brindes)</Typography></li>
            <li><Typography variant="body1">Imagem/voz (participação em campanhas, vídeos, avatar)</Typography></li>
            <li><Typography variant="body1">Placa de veículo (se o benefício do Parceiro exigir esta validação)</Typography></li>
            <li><Typography variant="body1">Selfie/biometria (quando necessário para checagens antifraude/segurança)</Typography></li>
          </Box>
          <Typography variant="body1" paragraph>
            <strong>3.3. Dados gerados pelo uso da Plataforma</strong>
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">Métricas de uso (acessos, cliques, frequência, obras mais acessadas)</Typography></li>
            <li><Typography variant="body1">Avaliações e resenhas de obras</Typography></li>
            <li><Typography variant="body1">Dados de dispositivo e telemetria (ex.: versão do app, sistema operacional)</Typography></li>
            <li><Typography variant="body1">Cookies e tecnologias similares (vide Seção 10)</Typography></li>
          </Box>
          <Typography variant="body1" paragraph sx={{ fontStyle: 'italic' }}>
            Observação sobre compra avulsa e assinatura direta Reedy: tais modalidades ainda não estão disponíveis. Quando lançadas, poderemos solicitar dados adicionais para cobrança/pagamento (ex.: dados de faturamento tokenizados pelo provedor de pagamentos), sempre nos termos da LGPD e desta Política.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            4. Coleta de Dados
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>4.1.</strong> Diretamente de você: no cadastro, no uso do app, em formulários de suporte e em avaliações de obras.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>4.2.</strong> De Parceiros (quando seu acesso decorrer do contrato do Parceiro): recebemos dados mínimos de elegibilidade (ex.: nome, CPF, e-mail/telefone, identificadores de plano/benefício) para validar seu direito de acesso.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>4.3.</strong> De mídias externas: poderemos considerar reclamações/avaliações públicas (ex.: Reclame Aqui, redes sociais) para suporte, melhoria do serviço e prevenção de fraudes – sempre respeitando suas configurações de privacidade nessas plataformas.
          </Typography>
          <Typography variant="body1" paragraph>
            A lista de Parceiros não é fixa e não é publicada nesta Política. A relação, planos e regras de elegibilidade são definidos contratualmente entre Reedy e cada Parceiro.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            5. Finalidades, Operações e Bases Legais (LGPD, art. 7º)
          </Typography>
          <Typography variant="body1" paragraph>
            Para prestar nossos serviços e operar a Plataforma, a Reedy realiza o tratamento de dados pessoais para diferentes finalidades, cada uma vinculada a uma base legal prevista na Lei Geral de Proteção de Dados (LGPD).
          </Typography>
          <Typography variant="body1" paragraph>
            Em primeiro lugar, utilizamos seus dados para criar e gerenciar sua conta, bem como para validar sua elegibilidade ao benefício concedido por meio de Parceiros. Nesses casos, tratamos informações como nome, CPF, e-mail, telefone, data de nascimento e, quando aplicável, identificadores de plano ou benefício, com base na execução do contrato ou em nosso legítimo interesse de verificar a regularidade do acesso.
          </Typography>
          <Typography variant="body1" paragraph>
            Também tratamos dados para disponibilizar as obras digitais contratadas e permitir o uso adequado da Plataforma, registrando preferências, histórico de leituras e recomendações personalizadas. Esse tratamento tem como fundamento a execução do contrato estabelecido com você ou com o Parceiro que viabiliza o benefício.
          </Typography>
          <Typography variant="body1" paragraph>
            No âmbito de atendimento e suporte, utilizamos seus dados de contato (como nome, telefone, CPF e e-mail) para responder dúvidas, reclamações, sugestões ou solicitações diversas. Esse tratamento é necessário para a execução do contrato e, em alguns casos, também se apoia em nosso legítimo interesse em aprimorar o relacionamento com os usuários.
          </Typography>
          <Typography variant="body1" paragraph>
            Podemos ainda tratar informações relacionadas ao seu comportamento de uso da Plataforma, avaliações de obras e feedbacks, a fim de analisar e melhorar continuamente nossos produtos e serviços. Nessas situações, utilizamos como fundamento o legítimo interesse e, quando aplicável, o consentimento do usuário, especialmente em pesquisas voluntárias.
          </Typography>
          <Typography variant="body1" paragraph>
            Para fins de comunicação e marketing, podemos enviar notificações, e-mails, SMS ou mensagens push sobre serviços, novidades e campanhas relacionadas à Reedy. Esse tratamento poderá se basear no consentimento do usuário (quando exigido) ou no legítimo interesse, sempre garantindo mecanismos de opt-out para quem desejar não receber tais comunicações.
          </Typography>
          <Typography variant="body1" paragraph>
            Além disso, realizamos o tratamento de dados para fins de segurança e prevenção a fraudes, incluindo a análise de informações de dispositivos e logs de acesso. Nesses casos, o fundamento aplicável é o legítimo interesse da Reedy em proteger a Plataforma, aliado ao cumprimento de obrigações legais quando se tratar da guarda de registros.
          </Typography>
          <Typography variant="body1" paragraph>
            Por fim, em situações específicas, poderemos tratar ou compartilhar dados para cumprimento de obrigações legais ou regulatórias, responder a requisições de autoridades competentes ou atender determinações judiciais.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            6. Compartilhamento com Terceiros
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>6.1. Operadores (fornecedores):</strong> infraestrutura de nuvem/hosting, analytics, antifraude, atendimento, e-mail/SMS/push, provisão de pagamentos (quando disponível), auditoria e segurança. Exigimos contratos com cláusulas de proteção de dados e confidencialidade.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>6.2. Parceiros:</strong> compartilhamos estritamente o necessário para (i) validar elegibilidade; (ii) apurar métricas contratuais; (iii) cumprir obrigações contratadas.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>6.3. Autoridades:</strong> podemos compartilhar para cumprir ordens judiciais/administ. e obrigação legal.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>6.4. Operações societárias:</strong> em fusão, cisão, aquisição, investimento ou reestruturação, os dados podem ser transferidos, com manutenção das garantias de privacidade.
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontWeight: 600 }}>
            Não vendemos dados pessoais.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            7. Transferências Internacionais
          </Typography>
          <Typography variant="body1" paragraph>
            Podemos armazenar ou processar dados em provedores localizados no exterior (ex.: Estados Unidos). Nessas hipóteses, adotamos salvaguardas compatíveis com a LGPD (cláusulas contratuais, padrões de segurança e governança compatíveis) e orientações da ANPD.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            8. Segurança da Informação
          </Typography>
          <Typography variant="body1" paragraph>
            Adotamos medidas técnicas e organizacionais proporcionais ao risco, incluindo: controle de acesso, criptografia em repouso e/ou trânsito quando aplicável, segregação de ambientes, monitoramento e logs.
          </Typography>
          <Typography variant="body1" paragraph>
            Nenhuma plataforma é 100% imune a incidentes. Se houver incidente de segurança com risco ou dano relevante, comunicaremos você e a ANPD quando exigido.
          </Typography>
          <Typography variant="body1" paragraph>
            A sua colaboração é essencial: use senhas fortes, não compartilhe credenciais e nos avise sobre suspeitas de comprometimento.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            9. Crianças e Adolescentes
          </Typography>
          <Typography variant="body1" paragraph>
            A Plataforma não é destinada a menores sem supervisão. Quando aplicável, o tratamento de dados de menores observará o melhor interesse do menor e, quando exigido, consentimento específico e em destaque de pelo menos um dos pais ou responsável legal (LGPD, art. 14).
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            10. Cookies e Tecnologias Similares
          </Typography>
          <Typography variant="body1" paragraph>
            Utilizamos cookies (sessão e persistentes) e identificadores de dispositivo para:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">(i) manter sua sessão;</Typography></li>
            <li><Typography variant="body1">(ii) lembrar preferências;</Typography></li>
            <li><Typography variant="body1">(iii) analytics;</Typography></li>
            <li><Typography variant="body1">(iv) eventualmente marketing (com opt-out).</Typography></li>
          </Box>
          <Typography variant="body1" paragraph>
            Você pode gerenciar cookies no navegador/dispositivo; alguns recursos podem ficar indisponíveis se determinados cookies forem bloqueados.
          </Typography>
          <Typography variant="body1" paragraph>
            Cookies de terceiros têm políticas próprias.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            11. Qualidade e Minimização dos Dados
          </Typography>
          <Typography variant="body1" paragraph>
            Mantemos os dados exatos e atualizados quando necessário, e limitamos o tratamento ao mínimo necessário para as finalidades informadas (LGPD – necessidade e adequação). Podemos solicitar a atualização de seus dados periodicamente.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            12. Retenção e Logs
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>12.1.</strong> Conservamos dados pelo tempo necessário para cumprir as finalidades e obrigações legais/contratuais.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>12.2.</strong> Logs de acesso a aplicações são mantidos por no mínimo 6 (seis) meses, conforme Marco Civil da Internet (Lei 12.965/2014) e decretos/atos correlatos.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>12.3.</strong> Para defesa de direitos (prazo prescricional), dados podem ser mantidos por período superior, com uso restrito a essa finalidade.
          </Typography>
          <Typography variant="body1" paragraph>
            <strong>12.4.</strong> Quando não houver base legal para manter, providenciaremos eliminação ou anonimização segura.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            13. Direitos do Titular
          </Typography>
          <Typography variant="body1" paragraph>
            Nos termos da LGPD, você pode solicitar:
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">Confirmação de tratamento e acesso aos dados;</Typography></li>
            <li><Typography variant="body1">Correção de dados incompletos, inexatos ou desatualizados;</Typography></li>
            <li><Typography variant="body1">Anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade;</Typography></li>
            <li><Typography variant="body1">Portabilidade (observados segredos comercial/industrial e regulação da ANPD);</Typography></li>
            <li><Typography variant="body1">Eliminação de dados tratados com base no consentimento;</Typography></li>
            <li><Typography variant="body1">Informações sobre compartilhamentos;</Typography></li>
            <li><Typography variant="body1">Revogação do consentimento quando aplicável;</Typography></li>
            <li><Typography variant="body1">Oposição a tratamento baseado em legítimo interesse, se houver descumprimento da LGPD;</Typography></li>
            <li><Typography variant="body1">Revisão de decisões automatizadas que afetem seus interesses, quando aplicável.</Typography></li>
          </Box>
          <Typography variant="body1" paragraph>
            Como exercer: 📩 suporte@reedy.com.br
          </Typography>
          <Typography variant="body1" paragraph>
            Responderemos nos prazos da LGPD. Você também pode reclamar à ANPD.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            14. Suas Responsabilidades
          </Typography>
          <Typography variant="body1" paragraph>
            Forneça dados verdadeiros e atualizados; mantenha sigilo das credenciais; utilize a Plataforma de forma lícita e conforme nossos Termos de Uso.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            15. Parceiros (B2B)
          </Typography>
          <Box component="ul" sx={{ pl: 3, mb: 2 }}>
            <li><Typography variant="body1">A elegibilidade e os parâmetros de acesso do usuário final são definidos contratualmente entre Reedy e o Parceiro.</Typography></li>
            <li><Typography variant="body1">A Reedy não assume obrigações perante clientes do Parceiro que extrapolem a operação da Plataforma e a disponibilização das obras.</Typography></li>
            <li><Typography variant="body1">Os Parceiros são independentes e responsáveis por suas próprias políticas e comunicações com seus clientes.</Typography></li>
          </Box>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            16. Atualizações desta Política
          </Typography>
          <Typography variant="body1" paragraph>
            Podemos alterar esta Política a qualquer tempo para refletir mudanças legais, regulatórias, tecnológicas ou de negócio, com base na liberdade contratual (CC arts. 421 e 421-A) e no regime de contratos de adesão (CDC art. 54, quando aplicável).
          </Typography>
          <Typography variant="body1" paragraph>
            A versão vigente será sempre a disponível na Plataforma. O uso continuado após a publicação implica ciência e aceitação da nova versão. Quando a lei exigir, solicitaremos novo consentimento.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            17. Lei Aplicável
          </Typography>
          <Typography variant="body1" paragraph>
            Esta Política é regida pelas leis da República Federativa do Brasil, em especial a LGPD (Lei 13.709/2018), o Marco Civil da Internet (Lei 12.965/2014) e o Código de Defesa do Consumidor quando aplicável.
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mb: 4 }}>
          <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: 600, mt: 3, mb: 2 }}>
            18. Contato (inclusive DPO)
          </Typography>
          <Typography variant="body1" paragraph>
            Dúvidas, solicitações de direitos e incidentes de segurança:
          </Typography>
          <Typography variant="body1" paragraph sx={{ fontWeight: 600 }}>
            📩 suporte@reedy.com.br
          </Typography>
        </Box>

        <Divider sx={{ my: 4 }} />

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            REEDY® 2025 – Todos os direitos reservados.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicyPage;

